export default __webpack_public_path__ + "static/media/Dropoff_Number.0fa20534.svg";